import { getFormHash } from '@tf/shared';
import { T } from '@tf/utils';
import type React from 'react';
import { Navigate } from 'react-router-dom';

import { useApplicationForms } from '@/components/application';
import { endClientAreaPaths } from '@/routes/endClientArea/paths';

import { useApplicationNodeIdParam } from './params';

export const ApplicationRoute: React.FC = () => {
	const applicationKind = useApplicationNodeIdParam();

	const forms = useApplicationForms();
	const firstForm = forms[0];
	T.assertNotNullish(firstForm, 'no forms');

	const firstFormUrl = endClientAreaPaths.applicationForm(applicationKind, firstForm.name, getFormHash(firstForm));

	return <Navigate to={firstFormUrl} replace />;
};
